module.exports = __webpack_public_path__ + "click-on-call-grey.png?e783d63ff0a050bc54dd928343baffc7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/click-on-call-grey.png
// module id = 21
// module chunks = 0